// helpers function to use in components

import axios from "axios";

class Action {
  constructor(action, data) {
    this.device = navigator.platform;
    this.action = action;
    this.data = data;
    this.date = new Date().toLocaleDateString("fr-FR");
    this.hour = new Date().toLocaleTimeString();
    this.browser = navigator.userAgent;
  }
}

/** API POST monitore **/

export async function monitore(action, data) {
  // Recupération des champs
  let url = "/monitoring";
  try {
    action = new Action(action, data);
    // console.log("action.toJSON", JSON.stringify(action));
    var request = {
      method: "POST",
      url: url,
      data: JSON.parse(JSON.stringify(action)),
    };
    await axios(request);
  } catch (err) {
    console.error(err);
  }
}